export const BITFINEX_LABEL = 'BITFINEX';
export const BITFINEX_SWAP_LABEL = 'BITFINEX_SWAP';

export const EXCHANGES = {
  bitfinex: BITFINEX_LABEL,
  bitfinexSwap: BITFINEX_SWAP_LABEL
};

export enum Exchange {
  BITFINEX = 'BITFINEX',
  BITFINEX_SWAP = 'BITFINEX_SWAP'
}
